import { render, staticRenderFns } from "./ReloadIcon.vue?vue&type=template&id=2135707a&"
import script from "./ReloadIcon.vue?vue&type=script&lang=js&"
export * from "./ReloadIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports